<template>
  <h1
    v-if="!!content"
    class="transition-opacity fixed text-hero text-white top-0 left-0 z-10 leading-none mt-16 lg:mt-24 ml-4 pointer-events-none opacity-0"
    :class="{ 'opacity-1': opacity }"
  >
    {{ content.fields.heroText }}
  </h1>
</template>

<script>
import { getGlobal } from "@/utils/IO";

export default {
  name: "HeroText",

  data: () => ({
    content: null,
    opacity: false
  }),

  async created() {
    this.content = await getGlobal();
  },

  mounted() {
    const timeIn = 2000;
    const timeOut = 7000;
    setTimeout(() => (this.opacity = true), timeIn);
    setTimeout(() => (this.opacity = false), timeIn + timeOut);
  }
};
</script>

<style scoped>
.text-hero {
  font-size: 32px;
}

.opacity-1 {
  opacity: 1;
}

@screen lg {
  .text-hero {
    font-size: 93px;
  }
}

@screen 2xl {
  .text-hero {
    font-size: 104px;
  }
}

.transition-opacity {
  transition-property: opacity;
  transition-duration: 1.5s;
}
</style>
